import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables'

export const PartnerCaseList_Filter = async (data) => {

    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `PartnerCase/FilterPartnerCase`, JSON.stringify(data), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetUniversalFilterPartnerCaseData = async (searchData) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `PartnerCase/GetUniversalFilterPartnerCaseData?searchdata=${searchData}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetPartnerContactDetails = async (clientCode) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `PartnerCase/GetPartnerContactDetails?clientCode=${clientCode}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetCasePatientDetails = async (searchdata, clientCode) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `PartnerCase/GetCasePatientDetails?searchdata=${searchdata}&clientCode=${clientCode}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetPartner_CaseCategoryList = async () => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `PartnerCase/GetPartner_CaseCategoryList`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetPartner_SR_TypeList_ByCategoryId = async (categoryId) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `PartnerCase/GetPartner_SR_TypeList_ByCategoryId?categoryId=${categoryId}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetPartner_SR_SubTypeList_ByCategoryId = async (srId) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `PartnerCase/GetPartner_SR_SubTypeList_ByCategoryId?srId=${srId}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const UploadMultiplePartner_SalesForce_Document = async (formData) => {

    const response = await trackPromise(axios.post(CommonVariables.API_DOMAIN + 'PartnerCase/UploadMultiplePartner_SalesForce_Document',
         formData, {
            headers: {
                ...CommonVariables.API_HEADER, 
                'Content-Type': 'multipart/form-data' // Ensure it's multipart
            }
        }))
        .then(response => response);
    return response;
}

export const CreatePartnerCase = async (caseData) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `PartnerCase/CreatePartnerCase`, JSON.stringify(caseData), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetPartnerCaseAttachments = async (caseId) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `PartnerCase/GetPartnerCaseAttachments?caseId=${caseId}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetPartnerCaseComments = async (caseId) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `PartnerCase/GetPartnerCaseComments?caseId=${caseId}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetPartnerCaseDetailByCaseNumber = async (caseNumber) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `PartnerCase/GetPartnerCaseDetailByCaseNumber?caseNumber=${caseNumber}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetPartnerCaseHistory = async (caseId) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `PartnerCase/GetPartnerCaseHistory?caseId=${caseId}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

// export const GetAccessControlMasterList = async () => {
//     var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `PartnerCase/GetAccessControlMasterList`, CommonVariables.API_HEADER)).then(response => response);
//     return result;
// }

export const GetCaseRecordTypeList = async () => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `PartnerCase/GetCaseRecordTypeList`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}